import { ReactKeycloakProvider } from '@react-keycloak/web'
import axios from 'axios'
import { useEffect, useRef, useState } from 'react'

import { appConfig } from '@/config/appConfig'
import { METACROC_HOMEPAGE } from '@/constants'
import keycloak from '@/endpoints/keycloak'

import { Root } from './Root'

export const Keycloak = () => {
	const [token, setToken] = useState<undefined | string>(undefined)
	const [tenantAllowed, setTenantAllowed] = useState(false)
	const loginPatched = useRef(false)

	useEffect(() => {
		if (!loginPatched.current) {
			const originalLogin = keycloak.login.bind(keycloak)
			keycloak.login = (options) => {
				const urlParams = new URLSearchParams(window.location.search)
				const idpFromUrl = urlParams.get('idp')
				const support = urlParams.has('support')

				const loginOptions = { ...options }
				if (support) {
					loginOptions.idpHint = 'master-oidc'
				} else if (idpFromUrl) {
					loginOptions.idpHint = idpFromUrl
				}

				return originalLogin(loginOptions)
			}
			loginPatched.current = true
		}
	}, [])

	useEffect(() => {
		axios
			.get(appConfig.apiUrl + '/init')
			.then((response) => {
				if (!response.data.allowed) {
					window.location.replace(METACROC_HOMEPAGE)
					return
				}

				if (response.data.goJSLicenseKey) {
					localStorage.setItem(
						'licenseKey',
						btoa(response.data.goJSLicenseKey),
					)
				}
				setTenantAllowed(true)
			})
			.catch(() => {
				// Network/server errors must not block login; only explicit
				// allowed:false redirects to the non-existing-tenant page.
				setTenantAllowed(true)
			})
	}, [])

	if (!tenantAllowed) {
		return null
	}

	return (
		<ReactKeycloakProvider
			initOptions={{
				onLoad: 'login-required',
				checkLoginIframe: true,
			}}
			authClient={keycloak}
			onTokens={(tokens) =>
				setToken((prev) => (prev === tokens.token ? prev : tokens.token))
			}
		>
			<Root token={token} />
		</ReactKeycloakProvider>
	)
}
